import { render, staticRenderFns } from "./FormPage.vue?vue&type=template&id=4b35270c&scoped=true"
import script from "./FormPage.vue?vue&type=script&lang=ts"
export * from "./FormPage.vue?vue&type=script&lang=ts"
import style0 from "./FormPage.vue?vue&type=style&index=0&id=4b35270c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b35270c",
  null
  
)

export default component.exports